<div class="flex flex-col">
    @if (label) {
        <div class="hypo-input-label">
            {{ label }}
            @if (showOptionalLabel()) {
                <span class="optional"></span>
            }
            @if (tooltip) {
                <app-tooltip [text]="tooltip"></app-tooltip>
            }
        </div>
    }

    <mat-form-field [floatLabel]="'always'" [formGroup]="formGroup" class="has-info date">
        <input
            [attr.data-testid]="testId"
            (focus)="datepicker.open()"
            [matDatepicker]="$any(datepicker)"
            [max]="max"
            [min]="min"
            formControlName="mainInput"
            matInput
            placeholder="d.m.yyyy" />
        <mat-datepicker-toggle [for]="datepicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #datepicker></mat-datepicker>
        @if (input.hasError('required')) {
            <mat-error align="end"> Povinný údaj </mat-error>
        }
        @if (input.hasError('matDatepickerMax')) {
            <mat-error align="end">
                Datum musí být menší než {{ input.getError('matDatepickerMax').max | date: 'd.M.y' }}
            </mat-error>
        }
        @if (input.hasError('matDatepickerMin')) {
            <mat-error align="end">
                Datum musí být větší než {{ input.getError('matDatepickerMin').min | date: 'd.M.y' }}
            </mat-error>
        }
    </mat-form-field>
</div>
